import { render, staticRenderFns } from "./TimelineViewerYear.vue?vue&type=template&id=0799b660&scoped=true&"
import script from "./TimelineViewerYear.vue?vue&type=script&lang=ts&"
export * from "./TimelineViewerYear.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineViewerYear.vue?vue&type=style&index=0&id=0799b660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799b660",
  null
  
)

export default component.exports